import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import DashboardPage from "../pages/dashboard/page";
import ProdutosPage from "../pages/produtos/page";
import VendasPage from "../pages/vendas/page";
import DespesasPage from "../pages/despesas/page";
import AportesPage from "../pages/aportes/page";
import RetiradasPage from "../pages/retiradas/page";
import RetiradaProdutosPage from "../pages/retirada-produtos/page";
import ClientesPage from "../pages/clientes/page";

const routes: RouteObject[] = [
  { path: "/", element: <DashboardPage /> },
  { path: "/produtos", element: <ProdutosPage /> },
  { path: "/vendas", element: <VendasPage /> },
  { path: "/despesas", element: <DespesasPage /> },
  { path: "/aportes", element: <AportesPage /> },
  { path: "/retiradas", element: <RetiradasPage /> },
  { path: "/retirada-produtos", element: <RetiradaProdutosPage /> },
  { path: "/clientes", element: <ClientesPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;